export const getUserAgent = () => {
  return typeof navigator === "undefined" ? "SSR" : navigator.userAgent;
};
